require("angular-i18n/en");

angular
    .module("Finance")
    //
    .config([
        "$translateProvider",
        function (translateProvider) {
            translateProvider
                .translations("en", require("../Translations/en.json"))
                .preferredLanguage("en");
        }
    ]);